import { style } from '@vanilla-extract/css';

import { tokens } from './tipJarTheme.css';

export const celebration = style({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '12px',
  padding: '4px 0',
  textAlign: 'center',
});

export const confetti = style({
  position: 'absolute',
  top: '28px',
  left: '50%',
  pointerEvents: 'none',
});

export const piece = style({
  position: 'absolute',
  width: '6px',
  height: '10px',
  borderRadius: '2px',
});

export const badge = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '48px',
  height: '48px',
  borderRadius: '999px',
  background: tokens.primary,
  color: tokens.onPrimary,
});

export const heading = style({
  margin: '4px 0 0',
  fontFamily: tokens.headerFont,
  fontSize: '24px',
  fontWeight: 700,
  lineHeight: '30px',
  letterSpacing: '-0.01em',
});

export const body = style({
  margin: 0,
  maxWidth: '420px',
  fontSize: '15px',
  lineHeight: '22px',
  color: tokens.muted,
});

export const quote = style({
  width: '100%',
  boxSizing: 'border-box',
  margin: '4px 0',
  padding: '16px 20px',
  borderRadius: tokens.fieldRadius,
  background: tokens.tint,
});

export const message = style({
  margin: 0,
  fontSize: '16px',
  lineHeight: '24px',
  color: tokens.ink,
  // The writer's own line breaks, without letting a long link push the card wider.
  whiteSpace: 'pre-line',
  overflowWrap: 'anywhere',
});
